import getIntlPolyfills from "./intl-polyfills";

export default (locale = "en") => [...getIntlPolyfills(locale)];
